import React, { useRef, useEffect } from 'react';
import { UPLOAD_BLOG_FILE } from './queries';
import { useMutation } from '@apollo/client';
import { TrixEditor } from 'react-trix';
import 'trix/dist/trix.css';
import { View, Dimensions } from 'react-native';
import Trix from "trix";
import styles from './styles.css';
import sanitizeHtml from 'sanitize-html';

const dimensions = Dimensions.get('window');
const smallScreen = dimensions.width < 800;

const videoRegex = /video\//;

const Editor = ({content, setContent }) => {
  const editorRef = useRef();

  const [uploadFile] = useMutation(UPLOAD_BLOG_FILE, {
    onCompleted: (fileResponse => {

    })
  });

  useEffect(() => {
    // const editorElement = editorRef.current?.editor?.element;

    // if (editorElement) {
    //   // Listen for the 'trix-file-accept' event to handle file uploads
    //   editorElement.addEventListener('trix-file-accept', handleFileAccept);
    // }

    // return () => {
    //   if (editorElement) {
    //     editorElement.removeEventListener('trix-file-accept', handleFileAccept);
    //   }
    // };
  }, [content]);

  const handleFileAccept = async (event) => {

    event.preventDefault();

    const file = event.file;
    const reader = new FileReader();

    reader.onload = async (e) => {
      const binaryStr = e.target.result;
      // Optionally, you can preview the file here
    };

    reader.readAsDataURL(file);
    try {

      const { data } = await uploadFile({ variables: { file: file } });
      if (data.uploadBlogFile.errors.length > 0) {
        return;
      }

      const fileUrl = data.uploadBlogFile.url;

      // Insert the file into the editor
      insertFile(file, fileUrl);
    } catch (error) {
      console.error('Upload Error:', error);
    }
  };

  const insertFile = (file, url) => {
    const editor = editorRef.current?.editor;

    if (editor) {
      const match = file.type.match(videoRegex);
      if (match) {
        editor.insertHTML(`<video controls><source src="${url}" type="${file.type}"></video>`)
        // const clean = sanitizeHtml(`<video controls><source src="${url}" type="${file.type}"></video>`, {
        //   allowedTags: [ 'video', 'source', ],
        //   allowedAttributes: {
        //     'video': [ 'controls' ],
        //     'source': [ 'src', 'type' ]
        //   },
        //   // allowedIframeHostnames: ['www.youtube.com']
        // });
        // editor.insertHTML(`<iframe width="500" height="500" src="${url}" frameborder="0"></iframe>`)

        // const videoElement = document.createElement('video');
        // videoElement.src = url;
        // videoElement.controls = true;
        // videoElement.style.maxWidth = '100%'; // Responsive

        // // Replace the placeholder with the actual video element
        // const attachmentElement = editor.querySelector(`[data-trix-attachment]`);
        // if (attachmentElement) {
        //   attachmentElement.innerHTML = ''; // Clear the current placeholder content
        //   attachmentElement.appendChild(videoElement);
        // }

      }else {
        editor.insertHTML(`<img src="${url}" alt="Uploaded File" />`);
      }
    }
  };

  const handleEditorReady = editor => {
    Trix.config.textAttributes.fontSize = {
      styleProperty: "font-size",
      inheritable: 1
    }
    Trix.HTMLSanitizer.sanitize = function(html, options) {
      const sanitizer = new this(html,
        {
          allowedAttributes: "style href src width height language class video source type controls".split(" "),
          forbiddenElements: []
        }
      )
      sanitizer.sanitize()
      return sanitizer;
    }

    // Customize Trix configuration here
    Trix.config.textAttributes = {
      ...Trix.config.textAttributes,
      video: {
        tagName: 'video',
        inheritable: true,
        parser: function (element) {
          return element.tagName === "video";
        }
      },
      source: {
        tagName: 'source',
        inheritable: true,
        parser: function (element) {
          return element.tagName === "source";
        }
      }
    };

    // Extend the list of allowed attributes for video
    Trix.config.blockAttributes.video = {
      tagName: "video",
      attributes: { controls: true, src: true }
    };

    // Allow 'source' tags within videos
    Trix.config.blockAttributes.source = {
      tagName: "source",
      attributes: { type: true, src: true }
    };

    Trix.config.blockAttributes.default = {
      ...Trix.config.blockAttributes.default,
      tagName: "div", // Keep default div tags
      parser: (element) => {
        return element.tagName !== "video"; // Prevent video tag from being removed
      }
    };

    Trix.config.blockAttributes.default = {
      ...Trix.config.blockAttributes.default,
      tagName: "div", // Keep default div tags
      parser: (element) => {
        return element.tagName !== "source"; // Prevent video tag from being removed
      }
    };

    const editorElement = editorRef.current?.editor?.element;

    if (editorElement) {
      // Listen for the 'trix-file-accept' event to handle file uploads
      editorElement.addEventListener('trix-file-accept', handleFileAccept);
    }

    return () => {
      if (editorElement) {
        editorElement.removeEventListener('trix-file-accept', handleFileAccept);
      }
    };

  };

  const handleChange = (html, text) => {
    setContent(html);
  };

  return (
    <View
      style={{
        minHeight: '100%',
        maxWidth: smallScreen ? '70%' : '100%'
      }}
    >
      <TrixEditor
        id="trixEditor"
        ref={editorRef}
        value={content}
        onChange={handleChange}
        placeholder="Enter Blog Content"
        style={{
          minHeight: '200px'
        }}

        onEditorReady={editor => handleEditorReady(editor)}
      />
    </View>
  )
}

export default Editor;